export enum AgreementType {
  INVESTMENT_OFFER = "INVESTMENT_OFFER",
  INVESTMENT_AGREEMENT_1 = "INVESTMENT_AGR",
  INVESTMENT_ACCEPT_1 = "INVESTMENT_ACC1",
  INVESTMENT_ACCEPT_2 = "INVESTMENT_ACC2",
  SALE_ORDER = "SALE_ORDER",
  PURCHASE_ORDER = "PURCHASE_ORDER",
  OTHER = "OTHER"
}
